// This file is automatically generated by internal/scripts/refresh-assets.ts.
// Do not edit manually. Or do, I'm a comment, not a cop.

/** @internal */
export const DEFAULT_TRANSLATION = {
	'action.toggle-auto-pan': 'Auto (trackpad)',
	'action.toggle-auto-zoom': 'Auto (mouse)',
	'action.toggle-auto-none': 'Auto',
	'action.toggle-mouse': 'Mouse',
	'action.toggle-trackpad': 'Trackpad',
	'action.convert-to-bookmark': 'Convert to bookmark',
	'action.convert-to-embed': 'Convert to embed',
	'action.open-embed-link': 'Open link',
	'action.align-bottom': 'Align bottom',
	'action.align-center-horizontal': 'Align horizontally',
	'action.align-center-vertical': 'Align vertically',
	'action.align-center-horizontal.short': 'Align H',
	'action.align-center-vertical.short': 'Align V',
	'action.align-left': 'Align left',
	'action.align-right': 'Align right',
	'action.align-top': 'Align top',
	'action.back-to-content': 'Back to content',
	'action.bring-forward': 'Bring forward',
	'action.bring-to-front': 'Bring to front',
	'action.copy-as-json.short': 'JSON',
	'action.copy-as-json': 'Copy as JSON',
	'action.copy-as-png.short': 'PNG',
	'action.copy-as-png': 'Copy as PNG',
	'action.copy-as-svg.short': 'SVG',
	'action.copy-as-svg': 'Copy as SVG',
	'action.copy': 'Copy',
	'action.copy-hovered-styles': 'Copy hovered styles',
	'action.cut': 'Cut',
	'action.delete': 'Delete',
	'action.unlock-all': 'Unlock all',
	'action.distribute-horizontal': 'Distribute horizontally',
	'action.distribute-vertical': 'Distribute vertically',
	'action.distribute-horizontal.short': 'Distribute H',
	'action.distribute-vertical.short': 'Distribute V',
	'action.download-original': 'Download original',
	'action.duplicate': 'Duplicate',
	'action.edit-link': 'Edit link…',
	'action.exit-pen-mode': 'Exit pen mode',
	'action.export-as-png.short': 'PNG',
	'action.export-as-png': 'Export as PNG',
	'action.export-as-svg.short': 'SVG',
	'action.export-as-svg': 'Export as SVG',
	'action.export-all-as-png.short': 'PNG',
	'action.export-all-as-png': 'Export as PNG',
	'action.export-all-as-svg.short': 'SVG',
	'action.export-all-as-svg': 'Export as SVG',
	'action.fit-frame-to-content': 'Fit to content',
	'action.flip-horizontal': 'Flip horizontally',
	'action.flip-vertical': 'Flip vertically',
	'action.flip-horizontal.short': 'Flip H',
	'action.flip-vertical.short': 'Flip V',
	'action.fork-project': 'Fork this project',
	'action.fork-project-on-tldraw': 'Fork project on tldraw',
	'action.frame-selection': 'Frame selection',
	'action.group': 'Group',
	'action.insert-embed': 'Insert embed…',
	'action.insert-media': 'Upload media…',
	'action.leave-shared-project': 'Leave shared project',
	'action.new-project': 'New project',
	'action.new-shared-project': 'New shared project',
	'action.open-cursor-chat': 'Cursor chat',
	'action.open-kbd-shortcuts': 'Keyboard shortcuts',
	'action.open-file': 'Open file',
	'action.pack': 'Pack',
	'action.paste': 'Paste',
	'action.paste-error-title': 'Pasting failed',
	'action.paste-error-description':
		'Could not paste due to missing clipboard permissions. Please enable the permissions and try again.',
	'action.print': 'Print…',
	'action.redo': 'Redo',
	'action.remove-frame': 'Remove frame',
	'action.rename': 'Rename',
	'action.rotate-ccw': 'Rotate counterclockwise',
	'action.rotate-cw': 'Rotate clockwise',
	'action.save-copy': 'Save a copy',
	'action.select-all': 'Select all',
	'action.select-none': 'Select none',
	'action.send-backward': 'Send backward',
	'action.send-to-back': 'Send to back',
	'action.share-project': 'Share this project',
	'action.stack-horizontal': 'Stack horizontally',
	'action.stack-vertical': 'Stack vertically',
	'action.stack-horizontal.short': 'Stack H',
	'action.stack-vertical.short': 'Stack V',
	'action.stop-following': 'Stop following',
	'action.stretch-horizontal': 'Stretch horizontally',
	'action.stretch-vertical': 'Stretch vertically',
	'action.stretch-horizontal.short': 'Stretch H',
	'action.stretch-vertical.short': 'Stretch V',
	'action.toggle-auto-size': 'Toggle auto size',
	'action.toggle-dark-mode.menu': 'Dark mode',
	'action.toggle-dark-mode': 'Toggle dark mode',
	'action.toggle-paste-at-cursor.menu': 'Paste at cursor',
	'action.toggle-paste-at-cursor': 'Toggle paste at cursor',
	'action.toggle-wrap-mode.menu': 'Select on wrap',
	'action.toggle-wrap-mode': 'Toggle select on wrap',
	'action.toggle-reduce-motion.menu': 'Reduce motion',
	'action.toggle-reduce-motion': 'Toggle reduce motion',
	'action.toggle-keyboard-shortcuts.menu': 'Enable keyboard shortcuts',
	'action.toggle-keyboard-shortcuts': 'Toggle keyboard shortcuts',
	'action.enhanced-a11y-mode.menu': 'Enhanced accessibility mode',
	'action.enhanced-a11y-mode': 'Toggle enhanced accessibility mode',
	'action.toggle-edge-scrolling.menu': 'Edge scrolling',
	'action.toggle-edge-scrolling': 'Toggle edge scrolling',
	'action.toggle-invert-zoom.menu': 'Invert mouse zoom',
	'action.toggle-invert-zoom': 'Toggle invert mouse zoom',
	'action.toggle-debug-mode.menu': 'Debug mode',
	'action.toggle-debug-mode': 'Toggle debug mode',
	'action.toggle-focus-mode.menu': 'Focus mode',
	'action.toggle-focus-mode': 'Toggle focus mode',
	'action.toggle-dynamic-size-mode.menu': 'Dynamic size',
	'action.toggle-dynamic-size-mode': 'Toggle dynamic size',
	'action.toggle-grid.menu': 'Show grid',
	'action.toggle-grid': 'Toggle grid',
	'action.toggle-lock': 'Toggle locked',
	'action.flatten-to-image': 'Flatten',
	'action.toggle-snap-mode.menu': 'Always snap',
	'action.toggle-snap-mode': 'Toggle always snap',
	'action.toggle-tool-lock.menu': 'Tool lock',
	'action.toggle-tool-lock': 'Toggle tool lock',
	'action.toggle-transparent.context-menu': 'Transparent',
	'action.toggle-transparent.menu': 'Transparent',
	'action.toggle-transparent': 'Toggle transparent background',
	'action.undo': 'Undo',
	'action.ungroup': 'Ungroup',
	'action.zoom-in': 'Zoom in',
	'action.zoom-out': 'Zoom out',
	'action.zoom-to-100': 'Zoom to 100%',
	'action.zoom-to-fit': 'Zoom to fit',
	'action.zoom-to-selection': 'Zoom to selection',
	'action.zoom-quick': 'Quick zoom',
	'action.select-zoom-tool': 'Zoom',
	'assets.files.size-too-big': 'File size is too big',
	'assets.files.maximum-size': 'Maximum file size is {size}',
	'assets.files.type-not-allowed': 'File type is not allowed',
	'assets.files.upload-failed': 'Upload failed',
	'assets.files.amount-too-many': 'Too many files',
	'assets.url.failed': 'Couldn’t load URL preview',
	'theme.dark': 'Dark',
	'theme.light': 'Light',
	'theme.system': 'System',
	'color-style.white': 'White',
	'color-style.black': 'Black',
	'color-style.blue': 'Blue',
	'color-style.green': 'Green',
	'color-style.grey': 'Grey',
	'color-style.light-blue': 'Light blue',
	'color-style.light-green': 'Light green',
	'color-style.light-red': 'Light red',
	'color-style.light-violet': 'Light violet',
	'color-style.orange': 'Orange',
	'color-style.red': 'Red',
	'color-style.violet': 'Violet',
	'color-style.yellow': 'Yellow',
	'fill-style.none': 'None',
	'document.default-name': 'Untitled',
	'fill-style.semi': 'Semi',
	'fill-style.solid': 'Solid',
	'fill-style.pattern': 'Pattern',
	'fill-style.fill': 'Fill',
	'fill-style.lined-fill': 'Lined fill',
	'dash-style.dashed': 'Dashed',
	'dash-style.dotted': 'Dotted',
	'dash-style.draw': 'Draw',
	'dash-style.solid': 'Solid',
	'size-style.s': 'Small',
	'size-style.m': 'Medium',
	'size-style.l': 'Large',
	'size-style.xl': 'Extra large',
	'opacity-style.0.1': '10%',
	'opacity-style.0.25': '25%',
	'opacity-style.0.5': '50%',
	'opacity-style.0.75': '75%',
	'opacity-style.1': '100%',
	'font-style.draw': 'Draw',
	'font-style.sans': 'Sans',
	'font-style.serif': 'Serif',
	'font-style.mono': 'Mono',
	'align-style.start': 'Start',
	'align-style.middle': 'Middle',
	'align-style.end': 'End',
	'align-style.justify': 'Justify',
	'verticalAlign-style.start': 'Top',
	'verticalAlign-style.middle': 'Middle',
	'verticalAlign-style.end': 'Bottom',
	'geo-style.arrow-down': 'Arrow down',
	'geo-style.arrow-left': 'Arrow left',
	'geo-style.arrow-right': 'Arrow right',
	'geo-style.arrow-up': 'Arrow up',
	'geo-style.cloud': 'Cloud',
	'geo-style.diamond': 'Diamond',
	'geo-style.ellipse': 'Ellipse',
	'geo-style.heart': 'Heart',
	'geo-style.hexagon': 'Hexagon',
	'geo-style.octagon': 'Octagon',
	'geo-style.oval': 'Oval',
	'geo-style.pentagon': 'Pentagon',
	'geo-style.rectangle': 'Rectangle',
	'geo-style.rhombus': 'Rhombus',
	'geo-style.rhombus-2': 'Rhombus left',
	'geo-style.star': 'Star',
	'geo-style.trapezoid': 'Trapezoid',
	'geo-style.triangle': 'Triangle',
	'geo-style.x-box': 'X box',
	'geo-style.check-box': 'Check box',
	'arrowheadStart-style.none': 'None',
	'arrowheadStart-style.arrow': 'Arrow',
	'arrowheadStart-style.bar': 'Bar',
	'arrowheadStart-style.diamond': 'Diamond',
	'arrowheadStart-style.dot': 'Dot',
	'arrowheadStart-style.inverted': 'Inverted',
	'arrowheadStart-style.pipe': 'Pipe',
	'arrowheadStart-style.square': 'Square',
	'arrowheadStart-style.triangle': 'Triangle',
	'arrowheadEnd-style.none': 'None',
	'arrowheadEnd-style.arrow': 'Arrow',
	'arrowheadEnd-style.bar': 'Bar',
	'arrowheadEnd-style.diamond': 'Diamond',
	'arrowheadEnd-style.dot': 'Dot',
	'arrowheadEnd-style.inverted': 'Inverted',
	'arrowheadEnd-style.pipe': 'Pipe',
	'arrowheadEnd-style.square': 'Square',
	'arrowheadEnd-style.triangle': 'Triangle',
	'spline-style.line': 'Line',
	'spline-style.cubic': 'Cubic',
	'arrow-kind-style.arc': 'Arc',
	'arrow-kind-style.elbow': 'Elbow',
	'tool.select': 'Select',
	'tool.hand': 'Hand',
	'tool.draw': 'Draw',
	'tool.eraser': 'Eraser',
	'tool.arrow-down': 'Arrow down',
	'tool.arrow-left': 'Arrow left',
	'tool.arrow-right': 'Arrow right',
	'tool.arrow-up': 'Arrow up',
	'tool.arrow': 'Arrow',
	'tool.cloud': 'Cloud',
	'tool.diamond': 'Diamond',
	'tool.ellipse': 'Ellipse',
	'tool.heart': 'Heart',
	'tool.hexagon': 'Hexagon',
	'tool.highlight': 'Highlight',
	'tool.line': 'Line',
	'tool.octagon': 'Octagon',
	'tool.oval': 'Oval',
	'tool.pentagon': 'Pentagon',
	'tool.rectangle': 'Rectangle',
	'tool.rhombus': 'Rhombus',
	'tool.star': 'Star',
	'tool.trapezoid': 'Trapezoid',
	'tool.triangle': 'Triangle',
	'tool.x-box': 'X box',
	'tool.check-box': 'Check box',
	'tool.media': 'Media',
	'tool.frame': 'Frame',
	'tool.note': 'Note',
	'tool.laser': 'Laser',
	'tool.embed': 'Embed',
	'tool.text': 'Text',
	'tool.pointer-down': 'Pointer down',
	'tool.image-zoom': 'Zoom',
	'tool.replace-media': 'Replace media…',
	'tool.flip-horz': 'Flip horizontally',
	'tool.flip-vert': 'Flip vertically',
	'tool.rotate-cw': 'Rotate',
	'tool.aspect-ratio': 'Aspect ratio',
	'tool.aspect-ratio.original': 'Original',
	'tool.aspect-ratio.square': 'Square (1:1)',
	'tool.aspect-ratio.circle': 'Circle (1:1)',
	'tool.aspect-ratio.landscape': 'Landscape (4:3)',
	'tool.aspect-ratio.portrait': 'Portrait (3:4)',
	'tool.aspect-ratio.wide': 'Wide (16:9)',
	'tool.image-toolbar-title': 'Image tools',
	'tool.image-crop': 'Crop image',
	'tool.image-crop-confirm': 'Confirm',
	'tool.media-alt-text': 'Alternative text',
	'tool.media-alt-text-desc': 'Give a description…',
	'tool.media-alt-text-confirm': 'Confirm',
	'tool.rich-text-bold': 'Bold',
	'tool.rich-text-italic': 'Italic',
	'tool.rich-text-code': 'Code',
	'tool.rich-text-highlight': 'Highlight',
	'tool.rich-text-strikethrough': 'Strikethrough',
	'tool.rich-text-link': 'Link',
	'tool.rich-text-link-visit': 'Visit link',
	'tool.rich-text-link-remove': 'Remove link',
	'tool.rich-text-header': 'Header',
	'tool.rich-text-bulletList': 'Bulleted list',
	'tool.rich-text-toolbar-title': 'Text formatting',
	'tool.rich-text-orderedList': 'Ordered list',
	'tool.bookmark': 'Bookmark',
	'a11y.status': 'Status',
	'a11y.skip-to-main-content': 'Move focus to canvas',
	'a11y.shape-index': '{num} of {total}',
	'a11y.shape-image': 'Image',
	'a11y.shape-video': 'Video',
	'a11y.multiple-shapes': '{num} shapes selected',
	'a11y.select-shape': 'Select next shape',
	'a11y.select-shape-direction': 'Select shape in direction',
	'a11y.enter-leave-container': 'Enter/leave container',
	'a11y.repeat-shape': 'Repeat shape',
	'a11y.move-shape': 'Move shape',
	'a11y.move-shape-faster': 'Move shape faster',
	'a11y.rotate-shape-cw': 'Rotate shape clockwise',
	'a11y.rotate-shape-ccw': 'Rotate shape counterclockwise',
	'a11y.rotate-shape-cw-fine': 'Rotate shape clockwise (fine)',
	'a11y.rotate-shape-ccw-fine': 'Rotate shape counterclockwise (fine)',
	'a11y.enlarge-shape': 'Enlarge shape',
	'a11y.shrink-shape': 'Shrink shape',
	'a11y.pan-camera': 'Pan camera',
	'a11y.adjust-shape-styles': 'Adjust shape styles',
	'a11y.open-context-menu': 'Context menu…',
	'a11y.open-keyboard-shortcuts': 'Keyboard shortcuts',
	'menu.title': 'Menu',
	'menu.theme': 'Theme',
	'menu.color-theme': 'Color theme',
	'menu.accessibility': 'Accessibility',
	'menu.copy-as': 'Copy as',
	'menu.edit': 'Edit',
	'menu.export-as': 'Export as',
	'menu.file': 'File',
	'menu.language': 'Language',
	'menu.preferences': 'Preferences',
	'menu.view': 'View',
	'menu.input-device': 'Input device',
	'context-menu.title': 'Context menu',
	'context-menu.edit': 'Edit',
	'context-menu.arrange': 'Arrange',
	'context-menu.copy-as': 'Copy as',
	'context-menu.export-as': 'Export as',
	'context-menu.export-all-as': 'Export',
	'context-menu.move-to-page': 'Move to page',
	'context-menu.reorder': 'Reorder',
	'page-menu.title': 'Pages',
	'page-menu.create-new-page': 'Create new page',
	'page-menu.max-pages-reached': 'Maximum pages reached',
	'page-menu.new-page-initial-name': 'Page 1',
	'page-menu.edit-start': 'Edit',
	'page-menu.edit-done': 'Done',
	'page-menu.go-to-page': 'Go to page',
	'page-menu.resize': 'Resize page list',
	'page-menu.submenu.rename': 'Rename',
	'page-menu.submenu.duplicate-page': 'Duplicate',
	'page-menu.submenu.title': 'Menu',
	'page-menu.submenu.move-down': 'Move down',
	'page-menu.submenu.move-up': 'Move up',
	'page-menu.submenu.delete': 'Delete',
	'share-menu.title': 'Share',
	'share-menu.save-note': 'Download this project to your computer as a .tldr file.',
	'share-menu.fork-note': 'Create a new shared project based on this snapshot.',
	'share-menu.share-project': 'Share this project',
	'share-menu.copy-link': 'Copy editor link',
	'share-menu.create-snapshot-link': 'Copy snapshot link',
	'share-menu.snapshot-link-note': 'Capture and share this project as a read-only snapshot link.',
	'share-menu.copy-readonly-link': 'Copy viewer link',
	'share-menu.offline-note': 'Create a new shared project based on your current project.',
	'share-menu.copy-link-note': 'Anyone with the link will be able to view and edit this project.',
	'share-menu.copy-readonly-link-note': 'Anyone with the link will be able to access this project.',
	'share-menu.project-too-large':
		'Sorry, this project can’t be shared because it’s too large. We’re working on it!',
	'share-menu.upload-failed':
		'Sorry, we couldn’t upload your project at the moment. Please try again or let us know if the problem persists.',
	'share-menu.creating-project': 'Creating the new project…',
	'share-menu.copied': 'Copied link',
	'document-name-menu.copy-link': 'Copy link',
	'status.offline': 'Offline',
	'people-menu.title': 'People',
	'people-menu.change-name': 'Change name',
	'people-menu.avatar-color': 'Avatar color',
	'people-menu.change-color': 'Change color',
	'people-menu.follow': 'Following',
	'people-menu.following': 'Following',
	'people-menu.leading': 'Following you',
	'people-menu.user': '(You)',
	'people-menu.invite': 'Invite others',
	'people-menu.anonymous-user': 'New user',
	'help-menu.import-tldr-file': 'Import file…',
	'help-menu.title': 'Help and resources',
	'help-menu.about': 'About tldraw',
	'help-menu.discord': 'Discord',
	'help-menu.github': 'GitHub',
	'help-menu.keyboard-shortcuts': 'Keyboard shortcuts',
	'help-menu.twitter': 'Twitter',
	'help-menu.terms': 'Terms of service',
	'help-menu.privacy': 'Privacy policy',
	'actions-menu.title': 'Actions',
	'edit-link-dialog.title': 'Edit link',
	'edit-link-dialog.invalid-url': 'A link must be a valid URL.',
	'edit-link-dialog.detail': 'Links will open in a new tab.',
	'edit-link-dialog.url': 'URL',
	'edit-link-dialog.clear': 'Clear',
	'edit-link-dialog.save': 'Continue',
	'edit-link-dialog.cancel': 'Cancel',
	'edit-link-dialog.external-link': 'External link',
	'embed-dialog.title': 'Insert embed',
	'embed-dialog.back': 'Back',
	'embed-dialog.create': 'Create',
	'embed-dialog.cancel': 'Cancel',
	'embed-dialog.url': 'URL',
	'embed-dialog.instruction': 'Paste in the site’s URL to create the embed.',
	'embed-dialog.invalid-url': 'We could not create an embed from that URL.',
	'shortcuts-dialog.title': 'Keyboard shortcuts',
	'shortcuts-dialog.edit': 'Edit',
	'shortcuts-dialog.file': 'File',
	'shortcuts-dialog.preferences': 'Preferences',
	'shortcuts-dialog.tools': 'Tools',
	'shortcuts-dialog.transform': 'Transform',
	'shortcuts-dialog.view': 'View',
	'shortcuts-dialog.collaboration': 'Collaboration',
	'shortcuts-dialog.a11y': 'Accessibility',
	'shortcuts-dialog.text-formatting': 'Text formatting',
	'shortcuts-dialog.disabled-notice':
		'Keyboard shortcuts are turned off. Turn them back on under Preferences > Accessibility.',
	'style-panel.title': 'Styles',
	'style-panel.align': 'Align',
	'style-panel.label-align': 'Label align',
	'style-panel.vertical-align': 'Vertical align',
	'style-panel.position': 'Position',
	'style-panel.arrowheads': 'Arrows',
	'style-panel.arrowhead-start': 'Start',
	'style-panel.arrowhead-end': 'End',
	'style-panel.arrow-kind': 'Line',
	'style-panel.color': 'Color',
	'style-panel.dash': 'Dash',
	'style-panel.fill': 'Fill',
	'style-panel.font': 'Font',
	'style-panel.geo': 'Shape',
	'style-panel.mixed': 'Mixed',
	'style-panel.opacity': 'Opacity',
	'style-panel.size': 'Size',
	'style-panel.spline': 'Spline',
	'style-panel.selected': 'selected',
	'tool-panel.title': 'Tools',
	'tool-panel.more': 'More',
	'navigation-zone.title': 'Navigation',
	'navigation-zone.minimap': 'Minimap',
	'navigation-zone.toggle-minimap': 'Toggle minimap',
	'navigation-zone.zoom': 'Zoom',
	'focus-mode.toggle-focus-mode': 'Toggle focus mode',
	'toast.close': 'Close',
	'toast.success': 'Success',
	'toast.error': 'Error',
	'toast.info': 'Info',
	'toast.warning': 'Warning',
	'file-system.file-open-error.title': 'Could not open file',
	'file-system.file-open-error.not-a-tldraw-file':
		'The file you tried to open doesn’t look like a tldraw file.',
	'file-system.file-open-error.file-format-version-too-new':
		'The file you tried to open is from a newer version of tldraw. Please reload the page and try again.',
	'file-system.file-open-error.generic-corrupted-file': 'The file you tried to open is corrupted.',
	'file-system.confirm-open.title': 'Overwrite current project?',
	'file-system.confirm-open.description':
		'Opening a file will replace your current project and any unsaved changes will be lost. Are you sure you want to continue?',
	'file-system.confirm-open.cancel': 'Cancel',
	'file-system.confirm-open.open': 'Open file',
	'file-system.confirm-open.dont-show-again': 'Don’t ask again',
	'file-system.confirm-clear.title': 'Clear current project?',
	'file-system.confirm-clear.description':
		'Creating a new project will clear your current project and any unsaved changes will be lost. Are you sure you want to continue?',
	'file-system.confirm-clear.cancel': 'Cancel',
	'file-system.confirm-clear.continue': 'Continue',
	'file-system.confirm-clear.dont-show-again': 'Don’t ask again',
	'file-system.shared-document-file-open-error.title': 'Could not open file',
	'file-system.shared-document-file-open-error.description':
		'Opening files from shared projects is not supported.',
	'sharing.confirm-leave.title': 'Leave current project?',
	'sharing.confirm-leave.description':
		'Are you sure you want to leave this shared project? You can return to it by navigating to its URL.',
	'sharing.confirm-leave.cancel': 'Cancel',
	'sharing.confirm-leave.leave': 'Leave',
	'sharing.confirm-leave.dont-show-again': 'Don’t ask again',
	'toast.error.export-fail.title': 'Failed export',
	'toast.error.export-fail.desc': 'Failed to export image',
	'toast.error.copy-fail.title': 'Failed copy',
	'toast.error.copy-fail.desc': 'Failed to copy image',
	'context.pages.new-page': 'New page',
	'vscode.file-open.desc':
		'We’ve updated this document to work with the current version of tldraw. If you’d like to keep the original version (which will work on old.tldraw.com), click below to create a backup.',
	'vscode.file-open.open': 'Continue',
	'vscode.file-open.backup': 'Backup',
	'vscode.file-open.backup-saved': 'Backup saved',
	'vscode.file-open.backup-failed': 'Backup failed: this is not a .tldr file.',
	'vscode.file-open.dont-show-again': 'Don’t ask again',
	'cursor-chat.type-to-chat': 'Type to chat…',
	'app.loading': 'Loading tldraw…',
	'handle.resize-top': 'Resize top',
	'handle.resize-bottom': 'Resize bottom',
	'handle.resize-left': 'Resize left',
	'handle.resize-right': 'Resize right',
	'handle.resize-top-left': 'Resize top left',
	'handle.resize-top-right': 'Resize top right',
	'handle.resize-bottom-left': 'Resize bottom left',
	'handle.resize-bottom-right': 'Resize bottom right',
	'handle.rotate.top_left_rotate': 'Rotate top left',
	'handle.rotate.top_right_rotate': 'Rotate top right',
	'handle.rotate.bottom_left_rotate': 'Rotate bottom left',
	'handle.rotate.bottom_right_rotate': 'Rotate bottom right',
	'handle.rotate.mobile_rotate': 'Rotate',
	'handle.crop.top': 'Crop top',
	'handle.crop.bottom': 'Crop bottom',
	'handle.crop.left': 'Crop left',
	'handle.crop.right': 'Crop right',
	'handle.crop.top-left': 'Crop top left',
	'handle.crop.top-right': 'Crop top right',
	'handle.crop.bottom-left': 'Crop bottom left',
	'handle.crop.bottom-right': 'Crop bottom right',
	'ui.close': 'Close',
	'ui.checked': 'Checked',
	'ui.unchecked': 'Unchecked',
	'comments.title': 'Comments',
	'comments.empty': 'No comments on this page yet.',
	'comments.empty-filtered': 'No comments match your filters.',
	'comments.thread-title': 'Comment',
	'comments.resolved': 'Resolved',
	'comments.filter': 'Filter comments',
	'comments.show-resolved': 'Show resolved comments',
	'comments.only-my-comments': 'Only my comments',
	'comments.only-unread': 'Only unread',
	'comments.show-all-pages': 'Show all pages',
	'comments.more-options': 'More options',
	'comments.hide': 'Hide comments',
	'comments.show': 'Show comments',
	'comments.reply-placeholder': 'Reply…',
	'comments.edit-placeholder': 'Edit comment…',
	'comments.add-placeholder': 'Add a comment…',
	'comments.save': 'Save',
	'comments.edit': 'Edit',
	'comments.resolve': 'Resolve',
	'comments.reopen': 'Reopen',
	'comments.delete': 'Delete thread',
	'comments.edit-comment': 'Edit comment',
	'comments.delete-comment': 'Delete comment',
	'comments.dismiss': 'Dismiss',
	'comments.copy-link': 'Copy link',
	'comments.link-copied': 'Link copied',
	'comments.send': 'Send',
	'comments.resolved-by': 'Resolved by {name}',
	'comments.add-reaction': 'Add reaction',
	'comments.reacted-1': '{a} reacted',
	'comments.reacted-2': '{a} and {b} reacted',
	'comments.reacted-3': '{a}, {b} and {c} reacted',
	'comments.reacted-more': '{a}, {b}, {c} and {count} others reacted',
	'comments.reacted-more-one': '{a}, {b}, {c} and 1 other reacted',
	'comments.mention-you': 'You',
	'comments.mention-no-matches': 'No matches',
	'comments.preview-more': '{count} more',
	'comments.replies-one': '1 reply',
	'comments.replies': '{count} replies',
	'comments.pin-label': 'Comment by {name}',
	'comments.pin-label-resolved': 'Resolved comment by {name}',
	'comments.cluster-label': '{count} comments here',
	'comments.stack-label': '{count} comments at this spot',
}
